<div class="d-flex">
  <div *ngFor="let sector of fixedSectors"
       [tooltipStr]="sector"
       class="tag tag-s-{{sectorColor(sector)}} mr-1">
    <i *ngIf="isApprovedSector(sector)" class="fa fa-check"></i>
  </div>
</div>
